import { doc, getDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";

const REGISTRATION_CODE_DOC = "settings/registrationCode";

/**
 * Hash a string using SHA-256
 */
async function hashCode(code: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(code);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

/**
 * Validate the registration code against the stored hash in Firestore
 * @param code The code entered by the user
 * @returns true if the code is valid, false otherwise
 */
export async function validateRegistrationCode(code: string): Promise<boolean> {
  try {
    // Get the stored hash from Firestore
    const docRef = doc(db, REGISTRATION_CODE_DOC);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      console.error("Registration code document not found in Firestore");
      return false;
    }

    const storedHash = docSnap.data()?.hash;
    if (!storedHash) {
      console.error("No hash found in registration code document");
      return false;
    }

    // Hash the entered code and compare
    const enteredHash = await hashCode(code);
    return enteredHash === storedHash;
  } catch (error) {
    console.error("Error validating registration code:", error);
    return false;
  }
}
